/*
 * Filter Anything v1.1.0
 * https://github.com/80DAYS/Filter-Anything
 */
$(document).ready(function() {
    $('[data-filter-work]').each(function() {
        var $_filterElement = $(this);
        var $_filterItems = $_filterElement.find('.' + $_filterElement.data('filter-class'));

        // Step 1: assemble a full list of each
        var filterCategories = '';
        var filterTags = '';
        $_filterItems.each(function() {
            if (typeof $(this).data('filter-categories') !== 'undefined') {
                filterCategories += $(this).data('filter-categories') + '|';
            }
            
            if (typeof $(this).data('filter-tags') !== 'undefined') {
                filterTags += $(this).data('filter-tags') + '|';
            }
        });
        filterCategories = filterCategories.substring(0, filterCategories.length - 1); // remove trailing |
        filterCategories = filterCategories.split('|'); // make it an array
        filterCategories = unique(filterCategories); // remove duplicates
        
        filterTags = filterTags.substring(0, filterTags.length - 1); // remove trailing |
        filterTags = filterTags.split('|'); // make it an array
        filterTags = unique(filterTags); // remove duplicates


        // Step 2: create the filter buttons
        var filterCategoryButtons = '';
        for (var category in filterCategories) {
            var filterCount = $_filterElement.find('.' + $_filterElement.data('filter-class') + '[data-filter-categories*="' + filterCategories[category] + '"]').length;
            if ( filterCount > 0 ) {
                filterCategoryButtons += '<li><button data-filter-category="' + filterCategories[category] + '">' + filterCategories[category] + ' (' + filterCount + ')</button></li>';
            }
        }
        $_filterElement.find('.filter__list-categories ul').append(filterCategoryButtons);
        
        
        var filterTagButtons = '';
        for (var tag in filterTags) {
            filterCount = $_filterElement.find('.' + $_filterElement.data('filter-class') + '[data-filter-tags*="' + filterTags[tag] + '"]').length;
            if ( filterCount > 0 ) {
                filterTagButtons += '<li><button data-filter-tag="' + filterTags[tag] + '">' + filterTags[tag] + ' (' + filterCount + ')</button></li>';
            }
        }
        $_filterElement.find('.filter__list-tags ul').append(filterTagButtons);



        // Step 4: set up the button events
        var $_filterButtons = $_filterElement.find('.filter__list button');

        $_filterButtons.on('click', function() {
            $(this).toggleClass('on');
            updateFilters();
            
            // Trigger event to allow other JS to interact with the filter change
            $_filterElement.trigger('filter-changed', $(this));
        });
        
        
        
        $_filterElement.find('.filter__clear button').on('click', function () {
            $_filterElement.find('.filter__list button').removeClass('on');
            updateFilters();
            $_filterElement.trigger('filter-changed', '');
        });


        
        
        function updateFilters() {
            // No filters selected so just show all items and quit
            if ( $_filterElement.find('.filter__list button.on').length === 0 ) {
                $_filterItems.fadeIn();
                return;
            }
            
            
            var selectedFilterCategories = '';
            var selectedFilterTags = '';
            
            // Make some lists of which filters are selected
            $_filterElement.find('.filter__list-categories button.on').each(function () {
                selectedFilterCategories += $(this).data('filter-category') + '|';
            });
            
            $_filterElement.find('.filter__list-tags button.on').each(function () {
                selectedFilterTags += $(this).data('filter-tag') + '|';
            });
            
            // Hide/show each item if they contain at least one of the categories or tags
            $_filterItems.each(function() {
                var shouldShowItem = false; // prove to me that you match the filters and should be shown
                var itemCategories = $(this).data('filter-categories').split('|');
                var itemTags = $(this).data('filter-tags').split('|');
                
                if ( itemCategories[0] !== '' ) {
                    for (var singleCategory in itemCategories) {
                        if ( selectedFilterCategories.indexOf(itemCategories[singleCategory]) > -1 ) {
                            shouldShowItem = true;
                        }
                    }
                }
                
                if ( itemTags[0] !== '' ) {
                    for (var singleTag in itemTags) {
                        if ( selectedFilterTags.indexOf(itemTags[singleTag]) > -1 ) {
                            shouldShowItem = true;
                        }
                    }
                }
                
                
                if ( shouldShowItem ) {
                    $(this).fadeIn();
                } else {
                    $(this).fadeOut();
                }
            });
        }


    });
});

// Filter a list to only unique values
// https://stackoverflow.com/questions/12551635/jquery-remove-duplicates-from-an-array-of-strings
function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}
